export interface ResolvedAssignmentWindows {
    pickUpStart?: number;
    pickUpEnd?: number;
    dropOffStart?: number;
    dropOffEnd?: number;
}

// Mirrors the backend's override-or-mirror logic (AssignmentExtensions.ToEntity /
// UpdateGeneralInformationHandler): pickUpWindow/dropOffWindow, when present, fully
// replace the base window's contribution for that side.
export const resolveAssignmentWindows = (
    baseWindow?: number[],
    pickUpWindow?: number[],
    dropOffWindow?: number[]
): ResolvedAssignmentWindows => {
    const baseStart = baseWindow?.[0];
    const baseEnd = baseWindow?.[1];

    const pickUpSpecified = pickUpWindow != null && pickUpWindow.length > 1;
    const dropOffSpecified = dropOffWindow != null && dropOffWindow.length > 1;

    return {
        pickUpStart: pickUpSpecified ? pickUpWindow![0] : baseStart,
        pickUpEnd: pickUpSpecified ? pickUpWindow![1] : baseEnd,
        dropOffStart: dropOffSpecified ? dropOffWindow![0] : baseStart,
        dropOffEnd: dropOffSpecified ? dropOffWindow![1] : baseEnd,
    };
};

// Widest [start, end] span across the base window and any specified overrides —
// used so overlap checks and urgency previews don't miss a window that was
// independently specified to extend outside the base window's range.
export const resolveAssignmentWindowEnvelope = (
    baseWindow?: number[],
    pickUpWindow?: number[],
    dropOffWindow?: number[]
): number[] | undefined => {
    const starts = [baseWindow?.[0], pickUpWindow?.[0], dropOffWindow?.[0]]
        .filter((value): value is number => value != null);
    const ends = [baseWindow?.[1], pickUpWindow?.[1], dropOffWindow?.[1]]
        .filter((value): value is number => value != null);

    if (starts.length === 0 || ends.length === 0) {
        return undefined;
    }

    return [Math.min(...starts), Math.max(...ends)];
};
